export const enum AzureVariable {
  insightId = '##__insight-id__##',
  authClientId = '##__auth-client-id__##',
  insurerId = '##__insurer-id__##',
  insurerName = '##__insurer-name__##',
  authIssuer = '##__auth-issuer__##',
  logActivationStateManagement = '##__log-activation-state-management__##',
  environmentName = '##__environment__##',
  horizonsDossierBaseUrl = '##__horizons-dossier-base-url__##',
}
